import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { LayoutService } from '../../@core/utils';

@Directive({
  selector: '[resize-box]',
  host: { '(window:resize)': 'onResize()' },
})
export class ResizeBox implements OnInit {
  @Input('resize-box') boxHeight: any;

  @Input('enalbeMargin') enalbeMargin: boolean = false;

  constructor(private element: ElementRef,
    private layoutService: LayoutService) {}

  ngOnInit(): void {
    this.onResize();
  }

  onResize() {
    const boxHeight = this.layoutService.useHeader ? this.boxHeight : 0;
    
    this.element.nativeElement.style.height = `${
      window.innerHeight - boxHeight
    }px`;
    
    if (this.enalbeMargin === false) {
      this.element.nativeElement.style.margin = '0px';
    }
  }
}
